var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonclose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M23.1 44.7801C35.1674 44.7801 44.95 34.9975 44.95 22.9301C44.95 10.8627 35.1674 1.08008 23.1 1.08008C11.0326 1.08008 1.25 10.8627 1.25 22.9301C1.25 34.9975 11.0326 44.7801 23.1 44.7801Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 44.7801C35.1674 44.7801 44.95 34.9975 44.95 22.9301C44.95 10.8627 35.1674 1.08008 23.1 1.08008C11.0326 1.08008 1.25 10.8627 1.25 22.9301C1.25 34.9975 11.0326 44.7801 23.1 44.7801Z",
    fill: "url(#paint0_linear_336_9256)",
    stroke: "url(#paint1_linear_336_9256)",
    strokeWidth: 0.89,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7999 14.8496L14.3999 31.0096",
    stroke: "white",
    strokeWidth: 1.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 14.8496L31.7999 31.0096",
    stroke: "white",
    strokeWidth: 1.77,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_9256",
    x1: 1.25,
    y1: 22.9301,
    x2: 44.94,
    y2: 22.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_9256",
    x1: 0.8,
    y1: 22.9301,
    x2: 45.39,
    y2: 22.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonclose);
export default __webpack_public_path__ + "static/media/buttonclose.aa87d3ab794d7f9cb654f47e062fff5d.svg";
export { ForwardRef as ReactComponent };